<template>
  <section class="story-block" :id="anchorId">
    <div class="container">
      <h2 v-if="data.content.section_title">{{ data.content.section_title }}</h2>
      <div class="story-content"><Arrow class='arrow float' /><span v-html="data.content.content" /></div>
    </div>
  </section>
</template>

<script setup>
import { useAnchorId } from '@/composables/useAnchorId';

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
});

const anchorId = useAnchorId(toRef(props, 'data'));
</script>

<style lang="scss" scoped>
.story-block {
  max-width: var(--main-width);
  margin-inline: var(--main-margin);
  overflow-x: hidden;
  border-radius: 4.25rem;
  background: var(--white);
  padding: 0;
  padding-bottom: 4rem;
}

h2 {
  margin-bottom:18rem;
}

.arrow.float {
  float: left;
}

.story-content {
  float: right;
  padding-bottom: 2rem;

  :deep(p) {
    font-size: clamp(2rem, 4vw, 2.25rem);
    margin-bottom: 1.5rem;
  }

  :deep(svg) {
    width: 3rem;
    height: 2.5rem;
    margin-right: 0.5rem;
  }

  :deep(svg) path, :deep(svg) line, :deep(svg) polyline  {
    stroke-width: 0.3em;
    stroke: var(--mahogany);
  }

  :deep(span) {
    display: inline;
  }

  :deep(h3) {
    margin-top: 2rem;
    margin-bottom: 1rem;
  }

  :deep(ul), :deep(ol) {
    margin-bottom: 1.5rem;
    padding-left: 2rem;
  }

  :deep(li) {
    margin-bottom: 0.5rem;
  }
}
</style>
